/* eslint-disable react/prop-types */
// React
import { FC, ReactNode } from 'react'

// Libraries
import { ThemeProvider } from 'styled-components'

// Custom
import { GENERAL } from 'locales'
import { theme, GlobalStyle } from 'lib/styled-components/theme'
import Header from 'components/Header'
import Footer from 'components/Footer'

// Fonts
import '@fontsource/lato'
import '@fontsource/lato/700.css'
import '@fontsource/lato/900.css'
import '@fontsource/inter'
import '@fontsource/inter/300.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

type Props = {
  children: ReactNode | ReactNode[]
  footer?: boolean
}

const ROUTES = [
  { label: GENERAL.navigation.home, path: '/' },
  { label: GENERAL.navigation.aboutUs, path: '/about-us' },
  // { label: GENERAL.navigation.projects, path: '/projects' },
  { label: GENERAL.navigation.contact, path: '/contact' },
]

const MOBILE = [
  { label: GENERAL.navigation.aboutUs, path: '/about-us' },
  { label: GENERAL.navigation.contact, path: '/contact' },
  // { label: GENERAL.navigation.projects, path: '/projects' },
  { label: GENERAL.navigation.joinUs, path: '/join-us' },
]

const COMPANY = [
  { label: GENERAL.navigation.aboutUs, path: '/about-us' },
  { label: GENERAL.navigation.contact, path: '/contact' },
  { label: GENERAL.navigation.joinUs, path: '/join-us' },
]

// const SOLUTIONS = [{ label: GENERAL.navigation.projects, path: '/projects' }]

const WrapProvider: FC<Props> = ({ children, footer = true }: Props) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Header navOptions={ROUTES} />
      {children}
      {footer && (
        <Footer
          navMobile={MOBILE}
          navCompany={COMPANY}
          // navSolutions={SOLUTIONS}
        />
      )}
    </ThemeProvider>
  )
}

export default WrapProvider
